// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1XbYR","head":"ProcedureTableInfo_head__11Nei"};